const awsconfig = {
    Auth: {
      region: 'us-east-1', 
      userPoolId: 'us-east-1_ZG8nZTkv6',
      userPoolWebClientId: '23eqnqs2hj1hdfd953vglstn7k',
    },
  };
  
  export default awsconfig;
  